import React from 'react'

import {cssTheme} from '@vio/atlas/src/themes'

export const PriceTrendDown = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    {...props}
  >
    <rect
      width={36}
      height={36}
      fill={cssTheme.colors.background.success.tertiary}
      rx={18}
    />
    <path
      fill={cssTheme.colors.content.success.primary}
      d="M22.167 23a.804.804 0 0 1-.593-.24.804.804 0 0 1-.24-.593c0-.236.08-.434.24-.594.16-.16.357-.24.593-.24H23.5l-4.333-4.291-2.75 2.75a.864.864 0 0 1-.583.23.784.784 0 0 1-.313-.064 1.094 1.094 0 0 1-.27-.166l-5.021-5.063a.765.765 0 0 1-.23-.562.8.8 0 0 1 .25-.584.79.79 0 0 1 .584-.229.79.79 0 0 1 .583.23L15.834 18l2.75-2.75a.735.735 0 0 1 .27-.177.928.928 0 0 1 .313-.052c.111 0 .215.017.313.052a.735.735 0 0 1 .27.177l4.917 4.917v-1.334c0-.236.08-.434.24-.594.16-.16.357-.239.593-.239s.434.08.594.24c.16.16.24.357.24.593v3.334c0 .236-.08.434-.24.593a.804.804 0 0 1-.594.24h-3.333Z"
    />
  </svg>
)
